import isEmpty from '../helpers/isEmpty'
//-------------------------------------
// get populated skill current no adjs
//-------------------------------------
export default function getPopulatedSkillCurNoAdjs(args) {
  const parent = args.parent_name
  const parent_cur_no_adjs = args.parent_cur_no_adjs
  const base = args.base
  const ticks = args.ticks
  const training = args.training

  let cur

  if (!isEmpty(parent)) {
    cur = parent + ' Cur No Adjs (' + parent_cur_no_adjs + ')'
  } else {
    cur = 'Base (' + base + ') + Ticks (' + ticks + ') + Training (' + training + ')'
  }

  return cur
}
